import { format, parseISO } from "date-fns"
import * as React from "react"
import { Calendar } from "@components/datePickers/components/Calendar"
import { Dropdown, DropdownButton, DropdownBody, Button } from "@components";
import { cn } from "@utils"
import { Calendar2 } from "react-bootstrap-icons";

export default function DatePicker({isoFormat = true, value, onChange, position, disabled}) {

  const parseDate = (dateValue) => {
    if (!dateValue) return null
    return isoFormat ? parseISO(dateValue) : new Date(dateValue)
  }

  const handleDateChange = (date) => {
    if (!date || !onChange) return;
    const formattedDate = isoFormat
      ? format(date, "yyyy-MM-dd") // Extracts only the YYYY-MM-DD part
      : date;

    onChange(formattedDate)
  }

  const selectedDate = parseDate(value)
  
  return (
    <Dropdown>
      <DropdownButton>
        <Button
          disabled={disabled}
          className={cn(
            "w-full flex justify-start text-left font-normal",
            !selectedDate && "text-muted-foreground"
          )}
        >
          <Calendar2 className="mr-2 h-4 w-4" />
          {selectedDate ? format(selectedDate, "PPP") : <span>Pick a date</span>}
        </Button>
      </DropdownButton>
      <DropdownBody position={position} className="w-auto p-0 calendar-container">
        <Calendar mode="single" selected={selectedDate} onSelect={handleDateChange} autoFocus />
      </DropdownBody>
    </Dropdown>
  )
}
